import LogoutIcon from '@mui/icons-material/Logout';
import { List, ListItemButton, ListItemIcon, ListItemText, useTheme } from '@mui/material';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

interface ProfileTabProps {
    handleLogout: () => void;
}

const ProfileTab = ({ handleLogout }: ProfileTabProps) => {
    const theme = useTheme();

    return (
        <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32, color: theme.palette.grey[500] } }}>
            <ListItemButton data-locator="logoutButton" onClick={handleLogout}>
                <ListItemIcon>
                    <LogoutIcon />
                </ListItemIcon>
                <ListItemText primary="Sign out" />
            </ListItemButton>
        </List>
    );
};

export default ProfileTab;
